export const environment = {
  production: true,
  mapsKey: {
    web: 'AIzaSyAtHk_zhmTcDzvS4JXUhWm8FF0AQIPw_-s',
    android: 'AIzaSyA_YxwXwArUVcynfig8kkVNWkNgRtrlSSk',
    ios: 'AIzaSyALTKSpAY4qEh7XZSWIFjjVmcMuNSf_nEA'
  },
  sentry: {
    dsn: 'https://67b9ae510966b72cac3332237a68379f@sentry.lisaas.com/5', // Replace with your actual Sentry DSN
    environment: 'live'
  }
};
